import { create } from 'zustand';
import type { MenuAction } from '../components/shared/ContextMenu';

interface ContextMenuState {
  isOpen: boolean;
  x: number;
  y: number;
  actions: MenuAction[];
  open: (x: number, y: number, actions: MenuAction[]) => void;
  close: () => void;
}

export const useContextMenu = create<ContextMenuState>((set) => ({
  isOpen: false,
  x: 0,
  y: 0,
  actions: [],
  open: (x, y, actions) => set({ isOpen: true, x, y, actions }),
  close: () => set({ isOpen: false, actions: [] }),
}));
